/* eslint-disable */
export default {
  noActiveCalls: '無使用中通話',
  noCalls: '找不到結果。',
  currentCall: '目前通話',
  ringCall: '撥打中通話',
  onHoldCall: '通話保留',
  historyCalls: '過去的通話',
  otherDeviceCall: '我的其他裝置上仍有進行中通話',
  searchPlaceholder: '搜尋...',
} as const;

// @key: @#@"noActiveCalls"@#@ @source: @#@"No active calls"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No results found."@#@
// @key: @#@"currentCall"@#@ @source: @#@"Current Call"@#@
// @key: @#@"ringCall"@#@ @source: @#@"Ringing Call"@#@
// @key: @#@"onHoldCall"@#@ @source: @#@"Call on Hold"@#@
// @key: @#@"historyCalls"@#@ @source: @#@"Past Calls"@#@
// @key: @#@"otherDeviceCall"@#@ @source: @#@"Ongoing calls on my other devices"@#@
// @key: @#@"searchPlaceholder"@#@ @source: @#@"Search..."@#@
